module.exports = __webpack_public_path__ + "static/media/fetal-pillow-logo-pwa@3x.7dcf0e12.jpg";